import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'core-column-names',
  templateUrl: './column-names.component.html',
})
export class ColumnNamesComponent {
  @ViewChild('strings', { static: true, read: ElementRef }) s: ElementRef;
}
